import { modelFromDto, modelToDto } from '../roles.exports';

export class Controller {

    /** @ngInject */
    constructor($state, Alert, RoleManagementResource) {
        this.$state = $state;
        this.Alert = Alert;
        this.RoleManagementResource = RoleManagementResource;
    }

    $onInit() {
        this.$model = modelFromDto(this.role, this.groups);
        this.model = modelFromDto(this.role, this.groups);
    }

    save() {
        this.isSaving = true;
        this.RoleManagementResource
            .save(this.companyId, this.appId, modelToDto(this.model))
            .then((roles) => Object.assign(this.roles, roles))
            .then(() => this.$state.rolesEdited = true)
            .then(() => this.$state.go('^'))
            .then(() => this.Alert('success', 'company.manage-application.roles.edit.saved'))
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return form.$invalid || this.isSaving || angular.equals(this.$model, this.model);
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/roles/edit/edit-role.controller.js